export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11271.dbc0262e.jpg";